const ITEMS = [
  "Private Chefs",
  "Lava Cave Galas",
  "VIP Nightlife",
  "Helicopter Transfers",
  "Icelandic Luxury",
  "Ice Cave Soirées",
  "Hot Spring Rituals",
  "Bottle Service",
  "Super-Jeep Safaris",
  "Secret Festivals",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-amber-500/15 bg-[#0c0c10] py-5">
    <div className="marquee-track flex w-max items-center whitespace-nowrap">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
          {ITEMS.map((item) => (
            <span key={`${dup}-${item}`} className="flex items-center">
              <span className="px-8 font-serif text-xl font-light italic tracking-wide text-amber-200/60 sm:text-2xl">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-amber-500/50" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
